<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--card -->
        <v-card class="form-card mx-auto my-12">
          <!--alert box-->
          <v-alert text prominent type="error" v-if="errorResponse">
            <div v-for="(error, i) in productGrouperror" :key="i">
              {{ error }}
            </div>
          </v-alert>
          <!--alert box end-->
          <v-list-item class="headline">
            <v-list-item-content>
              <v-list-item-title>
                PRODUCT GROUP ADD
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <!--form-->
          <form>
            <!--input field-->
            <v-card-text>
              <v-row justify="space-between">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    ref="product_groupname"
                    v-model="productgroupname"
                    :error-messages="productgroupnameErrors"
                    label="PRODUCT GROUP NAME*"
                    required
                    @input="$v.productgroupname.$touch()"
                    @blur="$v.productgroupname.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <!--input field end-->
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="black" dark @click="submit"> SUBMIT </v-btn>
              <v-btn color="warning" dark to="/product-group"> CANCEL </v-btn>
            </v-card-actions>
          </form>
          <!--form end-->
        </v-card>
        <!--card end-->
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProductGroupAdd",
  data: () => ({
    productgroupname: ""
  }),
  validations: {
    productgroupname: { required }
  },
  computed: {
    ...mapGetters(["productGroupStatus", "productGroupStatusResponse"]),
    productgroupnameErrors() {
      const errors = [];
      if (!this.$v.productgroupname.$dirty) return errors;
      !this.$v.productgroupname.required &&
        errors.push("Product Group Name is required.");
      return errors;
    },
    errorResponse: function() {
      return this.productGroupStatus === "error";
    },
    productGrouperror: function() {
      return this.productGroupStatusResponse;
    }
  },
  methods: {
    ...mapActions(["productgroupAdd"]),
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        // do your submit logic here
        setTimeout(() => {
          const productgroupData = {
            productgroupName: this.productgroupname.toUpperCase()
          };
          this.productgroupAdd(productgroupData);
          //console.log(productgroupData);
        }, 500);
      }
    }
  }
};
</script>
